import apiClient from './client.js'

async function getGenerations() {
  const response = await apiClient.get('/sync/generations')
  return response.data.accountGenerations
}

class SyncService {
  get = {
    /**
     * Read the live generation counters for the caller's accessible accounts.
     * The server derives the account set from the session (no params) and
     * returns every tracked domain.
     *
     * @returns {Promise<Record<string, Record<string, number>>>} Unwrapped from `response.data.accountGenerations`.
     */
    async generations() {
      return getGenerations()
    },
  }
}

export default new SyncService()
